import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import {
  HotBuyOrder,
  HotBuyOrderListResponse,
  HotBuyOrderRequest,
} from './types'
import { $sellPayoutsWithoutPagination } from '../../sell-payouts/list/model'

export const changedDateFormat = (date: Date) =>
  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map((item) => {
      if (item[0] === 'id') {
        return ['id', item[1]?.toLowerCase()]
      } else if (item[0] === 'addedAt') {
        const value =
          Array.isArray(item[1]) &&
          item[1].map((date) =>
            date ? changedDateFormat(date?.$d) : `${date}`,
          )
        return [item[0], value]
      }
      return [item[0], item[1]?.toLowerCase()]
    }),
  )
}

const isAllElementsOfSearchTextNotExist = (searchText: {
  [key: string]: string
}) => {
  return Object.values(searchText).every((item) => item === undefined)
}

export const hotBuyOrdersListMounted = createEvent<HotBuyOrderRequest>()

export const hotBuyOrdersListWithoutPaginationMounted = createEvent()

export const getHotBuyOrderList = fx<
  HotBuyOrderRequest,
  HotBuyOrderListResponse
>({
  method: 'GET',
  url: `/nova/p2p-sell-offer-buy`,
})

export const getHotBuyOrderListWithoutPagination = fx<
  void,
  HotBuyOrderListResponse
>({
  method: 'GET',
  url: `/nova/p2p-sell-offer-buy`,
})

export const $hotBuyOrders = restore<HotBuyOrder[]>(
  getHotBuyOrderList.doneData.map((a) => {
    return a.body.items.map((item) => {
      return { ...item, ...getExtFields(item) }
    })
  }),
  [],
)

export const $hotBuyOrdersWithoutPagination = restore<HotBuyOrder[]>(
  getHotBuyOrderListWithoutPagination.doneData.map((a) => {
    return a.body.items.map((item) => {
      return { ...item, ...getExtFields(item) }
    })
  }),
  [],
)

const getExtFields = (item: HotBuyOrder) => {
  return item.items.reduce(
    (acc: any, item) => {
      // acc.sellOfferIDs.push(item.SellOfferID)
      acc.totalSellAmount += +item.TotalPriceMaker
      acc.totalPriceFee += +item.TotalPriceFee
      return acc
    },
    {
      // sellOfferIDs: [],
      totalSellAmount: 0,
      totalPriceFee: 0,
    },
  )
}
export const $totalCountOfHotBuyOrders = restore(
  getHotBuyOrderList.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: hotBuyOrdersListMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText, filters }) => {
    if (orderDirection == 'descend') {
      orderDirection = '-'
    } else if (orderDirection == 'ascend') {
      orderDirection = ''
    }
    if (orderBy == 'orderId') {
      orderBy = 'id'
    }
    let query = {
      limit,
      page,
    }
    // @ts-ignore
    if (orderBy != '') {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }
    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      let newObj = Object.keys(filters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] =
            key === 'status' || key === 'backendStatus'
              ? filters[key as keyof typeof filters]
              : `${filters[key as keyof typeof filters]}`
        }

        return accumulator
      }, {} as any)

      if (!isAllElementsOfSearchTextNotExist(searchText)) {
        newObj = { ...newObj, ...mapSearchText(searchText) }
      }

      if (Object.keys(newObj).length) {
        // @ts-ignore
        query['where'] = `${JSON.stringify(newObj)}`
      }
    }

    return {
      query,
    }
  },
  target: getHotBuyOrderList,
})

sample({
  // @ts-ignore
  clock: hotBuyOrdersListWithoutPaginationMounted,
  target: getHotBuyOrderListWithoutPagination,
})
